export const messages = {
  en: {
    rechargeSetting: {
      title: 'Recharge Settings',
      queryCondition: 'Query Conditions',
      rechargeType: 'Recharge Type',
      rechargeTypePlaceholder: 'Please select recharge type',
      rechargeTypeName: 'Recharge Type Name',
      query: 'Query',
      add: 'Add',
      id: 'ID',
      notice: 'Notice',
      amountList: 'Amount List',
      fastAmountList: 'Fast Amount List',
      lowTime: 'Low Time',
      fastTime: 'Fast Time',
      remark: 'Remark',
      discountRate: 'Discount Rate',
      sort: 'Sort',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      export: 'Export',
      PHONE: 'Phone',
      ELECTRIC: 'Electric',
      WATER: 'Water',
      GAS: 'Gas',
      PROPERTY: 'Property'
    },
    addRechargeSetting: {
      title: 'Add Recharge Setting',
      rechargeType: 'Recharge Type',
      rechargeTypeRequired: 'Recharge type is required',
      rechargeTypeName: 'Recharge Type Name',
      rechargeTypeNamePlaceholder: 'Please enter recharge type name',
      notice: 'Notice',
      noticePlaceholder: 'Please enter notice content',
      amountList: 'Amount List',
      amountListPlaceholder: 'Optional recharge amounts, separated by commas. Example: 50,100,200,300,500',
      addAmount: 'Add Amount',
      discountAmount: 'Discount Amount',
      discountAmountPlaceholder: 'Enter discount amount',
      faceAmount: 'Face Amount',
      faceAmountPlaceholder: 'Enter face amount',
      amountListTip: 'Discount Amount: The amount user pays; Face Amount: The amount user receives after recharge',
      fastAmountList: 'Fast Amount List',
      fastAmountListTip: 'Fast charge amount list, same format as amount list',
      lowTime: 'Low Charge Time',
      lowTimePlaceholder: 'Enter low charge time',
      fastTime: 'Fast Charge Time',
      fastTimePlaceholder: 'Enter fast charge time',
      timeUnit: 'minutes',
      amountValidationError: 'Discount amount and face amount must be filled together',
      amountRequired: 'Please add at least one amount configuration',
      discountRate: 'Discount Rate',
      discountRatePlaceholder: 'Please enter discount rate',
      discountRateTip: '(0-1, e.g., 0.9 means 10% discount)',
      remark: 'Remark',
      remarkPlaceholder: 'Please enter remark',
      sort: 'Sort',
      sortPlaceholder: 'Please enter sort order',
      cancel: 'Cancel',
      save: 'Save',
      addSuccess: 'Add successful',
      addFailed: 'Add failed'
    },
    editRechargeSetting: {
      title: 'Edit Recharge Setting',
      rechargeType: 'Recharge Type',
      rechargeTypeRequired: 'Recharge type is required',
      rechargeTypeName: 'Recharge Type Name',
      rechargeTypeNamePlaceholder: 'Please enter recharge type name',
      notice: 'Notice',
      noticePlaceholder: 'Please enter notice content',
      amountList: 'Amount List',
      amountListPlaceholder: 'Optional recharge amounts, separated by commas. Example: 50,100,200,300,500',
      addAmount: 'Add Amount',
      discountAmount: 'Discount Amount',
      discountAmountPlaceholder: 'Enter discount amount',
      faceAmount: 'Face Amount',
      faceAmountPlaceholder: 'Enter face amount',
      amountListTip: 'Discount Amount: The amount user pays; Face Amount: The amount user receives after recharge',
      fastAmountList: 'Fast Amount List',
      fastAmountListTip: 'Fast charge amount list, same format as amount list',
      lowTime: 'Low Charge Time',
      lowTimePlaceholder: 'Enter low charge time',
      fastTime: 'Fast Charge Time',
      fastTimePlaceholder: 'Enter fast charge time',
      timeUnit: 'minutes',
      amountValidationError: 'Discount amount and face amount must be filled together',
      amountRequired: 'Please add at least one amount configuration',
      discountRate: 'Discount Rate',
      discountRatePlaceholder: 'Please enter discount rate',
      discountRateTip: '(0-1, e.g., 0.9 means 10% discount)',
      remark: 'Remark',
      remarkPlaceholder: 'Please enter remark',
      sort: 'Sort',
      sortPlaceholder: 'Please enter sort order',
      cancel: 'Cancel',
      save: 'Save',
      updateSuccess: 'Update successful',
      updateFailed: 'Update failed'
    },
    deleteRechargeSetting: {
      confirmOperation: 'Please confirm your operation!',
      confirmDelete: 'Confirm to delete this recharge setting?',
      cancel: 'Cancel',
      confirm: 'Confirm Delete!',
      deleteSuccess: 'Delete successful',
      deleteFailed: 'Delete failed'
    }
  },
  zh: {
    rechargeSetting: {
      title: '充值配置',
      queryCondition: '查询条件',
      rechargeType: '充值类型',
      rechargeTypePlaceholder: '请选择充值类型',
      rechargeTypeName: '充值类型名称',
      query: '查询',
      add: '新增',
      id: '编号',
      notice: '充值公告',
      amountList: '可选金额',
      fastAmountList: '快充可选金额',
      lowTime: '慢充到账时间',
      fastTime: '快充到账时间',
      remark: '备注',
      discountRate: '折扣比例',
      sort: '排序',
      operation: '操作',
      edit: '修改',
      delete: '删除',
      export: '导出',
      PHONE: '话费',
      ELECTRIC: '电费',
      WATER: '水费',
      GAS: '燃气费',
      PROPERTY: '物业费'
    },
    addRechargeSetting: {
      title: '新增充值配置',
      rechargeType: '充值类型',
      rechargeTypeRequired: '充值类型不能为空',
      rechargeTypeName: '充值类型名称',
      rechargeTypeNamePlaceholder: '请输入充值类型名称',
      notice: '充值公告',
      noticePlaceholder: '请输入公告内容',
      amountList: '可选金额',
      amountListPlaceholder: '可选充值金额，逗号分隔。例：50,100,200,300,500',
      addAmount: '添加金额',
      discountAmount: '优惠金额',
      discountAmountPlaceholder: '请输入优惠金额',
      faceAmount: '充值面额',
      faceAmountPlaceholder: '请输入充值面额',
      amountListTip: '优惠金额：用户实际支付金额；充值面额：用户充值后获得的金额',
      fastAmountList: '快充可选金额',
      fastAmountListTip: '快充金额列表，格式与可选金额相同',
      lowTime: '慢充到账时间',
      lowTimePlaceholder: '请输入慢充到账时间',
      fastTime: '快充到账时间',
      fastTimePlaceholder: '请输入快充到账时间',
      timeUnit: '小时',
      amountValidationError: '优惠金额和充值面额必须同时填写',
      amountRequired: '请至少添加一条金额配置',
      discountRate: '折扣比例',
      discountRatePlaceholder: '请输入折扣比例',
      discountRateTip: '（0-1，如0.9表示9折）',
      remark: '备注',
      remarkPlaceholder: '请输入备注',
      sort: '排序',
      sortPlaceholder: '请输入排序序号',
      cancel: '取消',
      save: '保存',
      addSuccess: '新增成功',
      addFailed: '新增失败'
    },
    editRechargeSetting: {
      title: '修改充值配置',
      rechargeType: '充值类型',
      rechargeTypeRequired: '充值类型不能为空',
      rechargeTypeName: '充值类型名称',
      rechargeTypeNamePlaceholder: '请输入充值类型名称',
      notice: '充值公告',
      noticePlaceholder: '请输入公告内容',
      amountList: '可选金额',
      amountListPlaceholder: '可选充值金额，逗号分隔。例：50,100,200,300,500',
      addAmount: '添加金额',
      discountAmount: '优惠金额',
      discountAmountPlaceholder: '请输入优惠金额',
      faceAmount: '充值面额',
      faceAmountPlaceholder: '请输入充值面额',
      amountListTip: '优惠金额：用户实际支付金额；充值面额：用户充值后获得的金额',
      fastAmountList: '快充可选金额',
      fastAmountListTip: '快充金额列表，格式与可选金额相同',
      lowTime: '慢充到账时间',
      lowTimePlaceholder: '请输入慢充到账时间',
      fastTime: '快充到账时间',
      fastTimePlaceholder: '请输入快充到账时间',
      timeUnit: '小时',
      amountValidationError: '优惠金额和充值面额必须同时填写',
      amountRequired: '请至少添加一条金额配置',
      discountRate: '折扣比例',
      discountRatePlaceholder: '请输入折扣比例',
      discountRateTip: '（0-1，如0.9表示9折）',
      remark: '备注',
      remarkPlaceholder: '请输入备注',
      sort: '排序',
      sortPlaceholder: '请输入排序序号',
      cancel: '取消',
      save: '保存',
      updateSuccess: '修改成功',
      updateFailed: '修改失败'
    },
    deleteRechargeSetting: {
      confirmOperation: '请确认您的操作!',
      confirmDelete: '确定删除该充值配置吗？',
      cancel: '点错了',
      confirm: '确认删除!',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败'
    }
  }
}